import React,{ useState } from "react";
import Card from "components/card";
import { Bell } from "lucide-react";
import AnnouncementCard from "../../client-dashboard/components/AnnouncementCard";
import { ANNOUNCEMENTS } from "./Announcements"
import AnnouncementWidget from "../../client-dashboard/components/AnnouncementWidget";

const AnnouncementBoard = () => {
    const [list, setList] = useState(ANNOUNCEMENTS);
    const [selectedId, setSelectedId] = useState(0);

    const handleRemove = (id) => {
        setList(prev => prev.filter((_, index) => index !== id));

        setSelectedId(prev => {
        if (prev === id) return 0;
        if (prev > id) return prev - 1;
        return prev;
        });
    };

    if (list.length === 0) return null;

    return (
        <Card className="text-slate-900 flex flex-col gap-6 rounded-xl border-2 border-slate-200 shadow-sm">
            <div className="grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 pt-6 pb-6 border-b border-slate-200 bg-white/20">
                <div className="flex items-center gap-2">
                    <div className="p-2 rounded-xl bg-purple-100">
                        <Bell className="w-5 h-5 text-purple-600" />
                    </div>
                    <div>
                        <h4 className="text-[18px] title-text">Important Announcements</h4>
                        <p className="text-[12px] muted-text">
                            Stay updated with company news and events
                        </p>
                    </div>
                </div>
            </div>
            <div className="pb-6 p-6">
                <div className="space-y-4">
                    <div className="mb-6 opacity-100 announcement transform-none">
                    {list
                        .filter((_, index) => index === selectedId)
                        .map((announcement, index) => (
                            <AnnouncementCard
                                key={index}
                                announcement={announcement}
                                isSelected={true}
                                onRemove={handleRemove}
                                selectedId={selectedId}
                            />
                    ))}
                    </div>
                    <div className="space-y-2">
                        <div className="flex items-center justify-between mb-2">
                            <h4 className="text-xs font-semibold muted-text">
                                All Announcements
                            </h4>
                            <div className="flex items-center gap-1">
                                {list.map((_, index) => (
                                    <button
                                        key={index}
                                        onClick={() => setSelectedId(index)}
                                        className={`rounded-full transition-all duration-300 ${
                                        index === selectedId
                                            ? "w-4 h-1.5 bg-violet-600 dark:bg-violet-500"
                                            : "w-1.5 h-1.5 bg-slate-300 hover:bg-slate-400"
                                        }`}
                                    >
                                    </button>
                                ))}
                            </div>
                        </div>
                        <AnnouncementWidget
                            announcements={list}
                            selectedId={selectedId}
                            setSelectedId={setSelectedId}
                            onRemove={handleRemove}
                            userType="employee"
                        />
                    </div>
                </div>
            </div>
        </Card>
    )
};
export default AnnouncementBoard;